/**
 * 내역 카드의 「대신 신청」 꼬리표(#332 · #258 차주가 자기 차 기사 이름으로 낸 것도 같은 표시).
 *   by      = 이 신청을 대신 넣은 기사(계산서 주인 ≠ 넣은 사람)
 *   forName = 내가 남 대신 넣은 신청 — 내 목록에도 보인다(취소는 그 기사 본인 또는 회계팀 · 서버도 주인만 받는다)
 */
export function ProxyTag({ by, forName }: { by?: string | null; forName?: string | null }) {
  if (forName) {
    return (
      <p className="mt-2 break-keep rounded-lg bg-amber-50 px-3 py-2 text-base text-amber-900">
        <b>{forName} 기사님 대신 신청</b> — 취소는 {forName} 기사님이 직접 하시거나 회계팀에 연락해 주세요.
      </p>
    );
  }
  if (by) return <p className="mt-2 inline-block rounded-lg bg-amber-50 px-3 py-1 text-base font-semibold text-amber-900">대신 신청: {by}</p>;
  return null;
}
